import { render } from "./IconCurvedArrowDown.vue?vue&type=template&id=ae211a00&scoped=true"
const script = {}

import "./IconCurvedArrowDown.vue?vue&type=style&index=0&id=ae211a00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae211a00"]])

export default __exports__